{
  "prompt": "Having trouble using this form?",
  "link": "Use the original Jotform application",
  "notice": "Your answers here will not transfer. You will need to enter them again in Jotform.",
  "previewNotice": "Your preview answers will not transfer. Jotform is a real application: submitting it sends your information.",
  "unavailable": "The original application is unavailable right now. Please try again later or contact the representative who shared this form."
}
